import React from 'react';
import { withTranslation } from 'react-i18next';
import $ from 'jquery'
import { constants } from '../constants/constants';
import {BllinkLogger} from '../utils/bllink_loggers';
import Parent from '../parent';
import './backNextBar.css';
import DropDown from '../simple/dropDown';
import Loader from "../simple/loader";
import offlinePaymentsLogic from "../../managers/offlinePayments/offlinePaymentsLogic";
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker.css';
import dayjs from "dayjs";
require('bootstrap-datepicker');


let navigation = {}
navigation[constants.pages.oneTimeTab] = {back: constants.pages.onGoingTab, next: constants.pages.lastConfirmPaymentPageUrl};
navigation[constants.pages.onGoingTab] = {back: constants.pages.debtTab, next: constants.pages.oneTimeTab};
navigation[constants.pages.debtTab] = {back: constants.pages.tenantDetailsUrl, next: constants.pages.onGoingTab};

const p = constants.pages;

export class BackNextBar extends Parent {

    constructor(props) {
        super(props);
        this.state = this.newState(props)

        BllinkLogger.info(`BackNextBar this.props `, props);

        this.adjustNavigationIfNeeded(props, this.state);
        this.bindNextAndBackButton.bind(this);
        this.renderHiddenEmptyCartPopUp.bind(this);
        this.renderHiddenTenantDetailsPopUp.bind(this);
        this.popUpOfflinePaymentClose.bind(this);
    }

    newState(props){

        return {
            buildingID: props.buildingID,
            apartmentNumber: props.apartmentNumber,
            currentTab: props.currentTab,
            checkoutPageUrl: props.isViewedAsManager ? p.lastConfirmPaymentManagerPageUrl: p.lastConfirmPaymentPageUrl,
            tenantDetailsUrl: props.isViewedAsManager ? p.tenantDetailsManagerUrl: p.tenantDetailsUrl,
            numberOfChecks: 1 // will determine the number of rows on the check pop up
        }
    }

    async componentDidMount() {
        BllinkLogger.info(`next bar componentDidMount`)
        this.bindNextAndBackButton(this.props.buildingID, this.props.apartmentNumber);
        const buildingData = await this.fetchBuildingData(this.props.buildingID);
        this.setState({
            currency: buildingData?.currency,
        });
        const thisObj = this;
        $(document).ready(function () {
            // bootstrap modal append to body - https://stackoverflow.com/a/15780841/13806459
            // https://app.asana.com/0/1196545425570329/1198890480504266

            // todo move all to paymentSection
            // $(`#offline-payments-${constants.managerPaymentsOptions.cheque}`).appendTo('body'); //moved to a separate page and not a popup
            $(`#offline-payments-${constants.managerPaymentsOptions.wire}`).appendTo('body');
            $(`#offline-payments-${constants.managerPaymentsOptions.cash}`).appendTo('body');
            $(`#offline-payments-${constants.managerPaymentsOptions.tenantRecordKey}`).appendTo('body');
            $('#amountsSentOfflinePaymentsAreWrong').appendTo('body');
            $(`#offline-payments-${constants.managerPaymentsOptions.tenantRecordKey} .btn_12`).click(() => {
                thisObj.popUpOfflinePaymentClose(constants.managerPaymentsOptions.tenantRecordKey);
            })
        });

        this.allEventBinds(thisObj);
    }

    componentDidUpdate(prevProps) {
        if (prevProps !== this.props) {
            BllinkLogger.info('BackNextBar componentDidUpdate', this.props);
            this.setState(this.newState(this.props));
            this.bindNextAndBackButton(this.props.buildingID, this.props.apartmentNumber);
            this.allEventBinds(this);
        }
    }

    allEventBinds(thisObj){
        thisObj.bindDatePicker();
        thisObj.bindLogExternalPaymentClicked();

        offlinePaymentsLogic.bindOfflineForms(thisObj);

    }

    adjustNavigationIfNeeded(props, state){
        /*
            if just one tab is enable, assign it's next to checkout page
            https://app.asana.com/0/1196545425570329/1199001958777525
            Next button not working with a single tab

         */

        navigation[constants.pages.oneTimeTab].next = state.checkoutPageUrl;
        navigation[constants.pages.debtTab].back = state.tenantDetailsUrl;
        this.adjustNavigationIfLessThanOneTab(props, state.checkoutPageUrl, state.tenantDetailsUrl);

    }

    adjustNavigationIfLessThanOneTab(props, checkoutPageUrl, tenantDetailsUrl){

        const stats = props.paymentsStats;
        const hasExactlyOneTab = (stats && stats.nonEmptyPayments === 1);
        const hasExactlyTwoTabs = (stats && stats.nonEmptyPayments === 2);
        if (hasExactlyOneTab){
            this.handleOneTabIsActive(stats, checkoutPageUrl, tenantDetailsUrl)
        }else if (hasExactlyTwoTabs){
            this.handleTwoTabs(stats, checkoutPageUrl, tenantDetailsUrl)
        }
    }

    handleOneTabIsActive(stats, checkoutPageUrl, tenantDetailsUrl){
        if (!stats.debtIsEmpty){
            navigation[constants.pages.debtTab].next = checkoutPageUrl;
            navigation[constants.pages.debtTab].back = tenantDetailsUrl;
        }
        if (!stats.monthlyIsEmpty){
            navigation[constants.pages.onGoingTab].next = checkoutPageUrl;
            navigation[constants.pages.onGoingTab].back = tenantDetailsUrl;
        }

        if (!stats.oneTimeIsEmpty){
            navigation[constants.pages.oneTimeTab].next = checkoutPageUrl;
            navigation[constants.pages.oneTimeTab].back = tenantDetailsUrl;
        }
    }

    handleTwoTabs(stats, checkoutPageUrl, tenantDetailsUrl){

        if (stats.debtIsEmpty){
            navigation[constants.pages.oneTimeTab].next = checkoutPageUrl;
            navigation[constants.pages.onGoingTab].back = tenantDetailsUrl;
        }

        if (stats.monthlyIsEmpty){
            navigation[constants.pages.debtTab].next = constants.pages.oneTimeTab;
            navigation[constants.pages.oneTimeTab].back = constants.pages.debtTab;
        }

        if (stats.oneTimeIsEmpty){
            navigation[constants.pages.onGoingTab].next = checkoutPageUrl;
        }

    }

    handleClicked(buildingID, apartmentNumber, currentTab, defaultUrl, typeOfButtonPressed){
        const allTabs = [constants.pages.onGoingTab, constants.pages.debtTab, constants.pages.oneTimeTab];
        const nextBackData = navigation[currentTab][typeOfButtonPressed];
        BllinkLogger.info(`currentTab is ${currentTab} and nextBackData `, nextBackData);
        let newUrl = defaultUrl;
        if (allTabs.includes(nextBackData)){
            this.props.onNextBackChange(nextBackData, false)
        }else{
            this.goToUrl(newUrl, this.props, this.state)
        }
    }

    bindNextAndBackButton(buildingID, apartmentNumber){

        const reactCo = this;
        const state = this.state;

        // todo validate some payments have been selected and raise an error is not
        BllinkLogger.info(`bindNextAndBackButton binding click, this.state`, this.state)
        // next button
        $('#txt-submit').click(function (e){
            e.preventDefault();
            const defaultUrl = `/${state.checkoutPageUrl}/${buildingID}/${apartmentNumber}`;
            reactCo.handleClicked(buildingID, apartmentNumber, state.currentTab, defaultUrl, 'next');
        })


        // back button
        $('#back-button-select-payments').click(function (e){
            e.preventDefault();

            const defaultUrl = `/${state.tenantDetailsUrl}/${buildingID}`;
            reactCo.handleClicked(buildingID, apartmentNumber, state.currentTab, defaultUrl, 'back');

        })

        const thisObj = this;
        // link to go straight to checkout
        $('.js-checkout').click(e => {
            e.preventDefault();

            thisObj.goToUrl($(e.target).attr('href'), thisObj.props, thisObj.state);
        })
    }

    goToUrl(url, props, state){
        // need to check if cart has items
        let params = {shouldHideCreditCardOption: props.shouldHideCreditCardOption};
        const detailsFilledAreValid = this.validateDetails(props.buildingID, props.apartmentNumber, params);
        if (detailsFilledAreValid){
            props.onNextBackChange(url, true, state);
        }
    }

    renderHiddenTenantDetailsPopUp(){
        const {t} = this.props;

        return this.renderHiddenPopUp({
            title: t('payments.tenant_details_missing_title'),
            id: 'tenantDetailsMissing',
            textLine1: t('payments.tenant_details_missing_text'),
        })

    }

    renderHiddenEmptyCartPopUp(){
       const {t} = this.props;

       return this.renderHiddenPopUp({
           title: t('payments.cart_empty_title'),
           id: 'cartIsEmpty',
           textLine1: t('payments.cart_empty_text'),
       })
    }

    renderHiddenCantPayWithCreditCardPopUp(){
        const {t} = this.props;

        return this.renderHiddenPopUp({
            title: t('payments.cant_pay_with_credit_card'),
            id: 'creditCardMethodError',
            textLine1: t('payments.cant_pay_with_credit_card_text'),
        })
    }

    renderHiddenWrongAmountsSentPopUp(){
        const {t} = this.props;

        return this.renderHiddenPopUp({
            title: t('payments.offline_payment_amounts_are_wrong'),
            id: 'amountsSentOfflinePaymentsAreWrong',
            textLine1: '...',
        })
    }

    renderCashHiddenPopUp(){
        const {t} = this.props;

        return (
            (
                <div className="modal fade" id={`offline-payments-${constants.managerPaymentsOptions.cash}`}>
                    <div className="modal-dialog new_modal_content">
                        <div className="modal-content n_content">
                            <div className="modal-header">
                                <h5 className="col-12 modal-title text-center" id="genericModalLabel">{t('offline_payments.pay_with_cash_title')}</h5>
                            </div>
                            <div className="modal-body">
                                <Loader/>
                                <form className='offline-payment-body js-offline-payment-form js-cash-form'>
                                    <div className="row">
                                    <div className="col-sm-6">
                                        <div className="form-group">
                                            <label>{t('offline_payments.amount')}:</label>
                                            <br/>
                                            <label className="js-total-amount-label">.. </label>
                                        </div>
                                    </div>
                                    <div className="col-sm-6">
                                        <div className="form-group" id="cnd-fg">
                                            <label htmlFor="date">{t('offline_payments.date_of_deposit')}: * </label>
                                            <span id="fm-grp">
                                               <input className="form-control hasDatepicker js-datepicker bllink-input-border"
                                                      name="datepicker"
                                                      id={`datepicker-${constants.managerPaymentsOptions.cash}`}
                                                      autoComplete="off"
                                                      style={{textAlign: "right"}}
                                               />
                                            </span>
                                        </div>

                                    </div>
                                    <button type="submit"
                                        arie-type={constants.managerPaymentsOptions.cashServerKey}
                                        className="bllink-button bllink-button-half js-log-payments-btn"
                                        >{t('offline_payments.make_offline_payment_button')}</button>
                                </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            )
        )
    }

    renderWireHiddenPopUp(){
        const {t} = this.props;
        return (
            (
                <div className="modal fade" id={`offline-payments-${constants.managerPaymentsOptions.wire}`}>
                    <div className="modal-dialog new_modal_content">
                        <div className="modal-content n_content">
                            <div className="modal-header">
                                <h5 className="col-12 modal-title text-center" id="genericModalLabel">{t('offline_payments.pay_with_wire_title')}</h5>
                            </div>
                            <div className="modal-body">
                                <Loader/>
                                <form className='offline-payment-body js-offline-payment-form js-wire-form'>
                                    <div className="row">
                                        <div className="col-sm-6">

                                            <div className="form-group js-bank-code">
                                                <label htmlFor="email">{t('offline_payments.bank_code_title')}:  </label>
                                                <DropDown
                                                    name="js-bank-code"
                                                    callingObj={this}
                                                    options={this.bankOptions(this.state.currency)}
                                                    includeEmptyOption={true}
                                                />
                                            </div>
                                            <div className="form-group">
                                                {/* todo auto fill after selecting bank */}
                                                <label htmlFor="email">{t('offline_payments.bank_branch_title')}:  </label>
                                                <input type="text" className="form-control js-branch bllink-input-border" name="branch-number"/>
                                            </div>
                                            <div className="inline_layout-bank_22 tooltipHover" id="recurrent-bank-wire-checkbox">
                                                <span class="tooltipText">{t('offline_payments.reccurent_wire_tooltip')}</span>
                                                <label className="label_container-bank_22">
                                                    <input type="checkbox" id="recurrent-bank-wire"/>
                                                        <span className="checkmark-bank_22"/>
                                                        {t('offline_payments.recurrent_bank_wires')}
                                                </label>
                                            </div>
                                        </div>
                                        <div className="col-sm-6">
                                            <div className="form-group" id="">
                                                <label htmlFor="date">{t('offline_payments.date')}: * </label>
                                                <span id="fm-grp">
                                                    <input type="text"
                                                       className="form-control js-datepicker bllink-input-border"
                                                       id={`datepicker-${constants.managerPaymentsOptions.wireServerKey}`}
                                                       name="datepicker" autoComplete="off"/>
                                                </span>
                                            </div>
                                            <div className="form-group" id="">
                                                <label htmlFor="email">{t('offline_payments.bank_account_number_title')}:  </label>
                                                <input type="text" className="form-control js-account-number bllink-input-border" name="account-number"/>
                                            </div>

                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <div className="form-group">
                                                <label>{t('offline_payments.amount')}:</label>
                                                <br/>
                                                <label className="js-total-amount-label">.. </label>
                                            </div>
                                        </div>
                                        <div className="col-sm-6">
                                            <button type="submit"
                                                    arie-type={constants.managerPaymentsOptions.wireServerKey}
                                                    className="bllink-button js-log-payments-btn "
                                                    >{t('offline_payments.make_offline_payment_button')}</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            )
        )
    }

    renderTenantRecordHiddenPopUp(){
        const {t} = this.props;

        return (
            (
                <div className="modal fade" id={`offline-payments-${constants.managerPaymentsOptions.tenantRecordKey}`}>
                    <div className="modal-dialog new_modal_content">
                        <div className="modal-content n_content">
                            <div className="modal-header">
                                <h5 className="col-12 modal-title text-center" id="genericModalLabel">{t('offline_payments.pay_with_tenant_record')}</h5>
                            </div>
                            <div className="modal-body">
                                <Loader/>
                                <form className='offline-payment-body js-offline-payment-form js-cash-form center-block'>
                                    <div>
                                        <label>{t('offline_payments.amount')}:</label>
                                        <br/>
                                        <label className="js-total-amount-label">.. </label>
                                    </div>
                                    <input className="hidden"
                                           name="datepicker"
                                           id={`datepicker-${constants.managerPaymentsOptions.tenantRecordKey}`}
                                           autoComplete="off"
                                           defaultValue={dayjs().format("DD/MM/YYYY")}
                                    />
                                    <div className="buttons-container">
                                         <button type="submit"
                                                 arie-type={constants.managerPaymentsOptions.tenantRecordKey}
                                                 className="bllink-button short-button js-log-payments-btn"
                                         >{t('offline_payments.confirmation')}</button>
                                         <button type="cancelation"
                                                 className="btn_12"
                                         >{t('offline_payments.cancellation')}</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            )
        )
    }

    render() {


        const {t} = this.props;
        BllinkLogger.info(`props next back`, this.props);
        const hasNoActivePayments = (this.props.paymentsStats && this.props.paymentsStats.nonEmptyPayments === 0);
        if (hasNoActivePayments){
            return <div/>
        }

        return (
            <div className="row last-sec-payment">
                <div className="col-md-6 text-right set_sec_w-1">
                    <a href="/" id="back-button-select-payments" className="reture">{t('payments.back')}</a>
                </div>
                <div className="col-md-6 set_sec_w">
                    <div className="row">
                        <div className="col-md-6 set_sec_w_3 proceed-to-checkout-mobile">
                            <p className="btn_p">
                                <a className="a_link js-checkout"
                                   href={`/${this.state.checkoutPageUrl}/${this.props.buildingID}/${this.props.apartmentNumber}`}>
                                    {t('payments.proceed_to_checkout')}</a>
                            </p>
                        </div>
                        <div className="col-md-6">
                            <input id="txt-submit" type="submit" current-tab={this.props.currentTab} name="submit-btn"
                                   value={t('payments.next')} />
                        </div>
                    </div>
                </div>
                {this.renderHiddenEmptyCartPopUp()}
                {this.renderHiddenTenantDetailsPopUp()}
                {this.renderHiddenWrongAmountsSentPopUp()}
                {this.renderHiddenCantPayWithCreditCardPopUp()}
                {/* move all offline payments popup to paymentSection.js with the cheque*/}
                {this.renderCashHiddenPopUp()}
                {this.renderWireHiddenPopUp()}
                {this.renderTenantRecordHiddenPopUp()}
            </div>
        )

    }
}

export default withTranslation()(BackNextBar);
